import React from 'react';
import IEmptyState from "EmptyState";
import { AssociationType } from "Pages/ProductPricing/AssociationType";
import { EventLocation } from "Pages/ProductPricing/EventLocation";
import PriceGridItem from "Shared/PriceGridItem";

interface IProductProps {
    title: string;
    subtitle?: string;
    quantity?: string;
    model?: string;
    fsaaPrice: string;
    ulPrice?: string;
    partnerPrice?: string;
    extPrice?: string;
    transportPriceBase?: number;
    transportPricePerKm?: number;
    pictureUrl?: string;
    thumbnailUrl: string;
    large?: boolean;
    cover?: boolean;
    associationType: AssociationType;
    eventLocation: EventLocation;
    link?: string;
}

export default class Product extends React.PureComponent<IProductProps, IEmptyState> {
    constructor(props: IProductProps) {
        super(props);
    }

    private get price() {
        switch (this.props.associationType) {
            case AssociationType.FSAA:
                return this.props.fsaaPrice;
            case AssociationType.AssoUL:
                return this.props.ulPrice;
            case AssociationType.Partner:
                return this.props.partnerPrice;
            case AssociationType.External:
                return this.props.extPrice;
        }
    }

    private get transportPrice() {
        if (this.props.transportPriceBase == undefined || this.props.transportPricePerKm == undefined) {
            return undefined;
        }
        switch (this.props.eventLocation) {
            case EventLocation.OffCampus:
                return `${this.props.transportPriceBase}$ + ${this.props.transportPricePerKm}$/km`;
            case EventLocation.OnCampus:
                return `${this.props.transportPriceBase}$`;
        }
    }

    public render() {
        return (
            <PriceGridItem
                title={this.props.title}
                overlayBottomText={this.props.quantity}
                pictureUrl={this.props.pictureUrl}
                thumbnailUrl={this.props.thumbnailUrl}
                subtitle={this.props.model ?? this.props.subtitle}
                mainPriceText={this.price}
                otherPriceText1={this.transportPrice != undefined ? 'Transport: ' + this.transportPrice : undefined}
                large={this.props.large}
                cover={this.props.cover}
                link={this.props.link}
            >
                {this.props.children}
            </PriceGridItem>
        );
    }
}